export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? "http://localhost:4000";
export const PAGE_LIMIT_FOR_USERS_FOR_EMAIL = 50
export const PAGE_LIMIT_FOR_EMAILS = 10
export const PAGE_LIMIT_FOR_NEW_SONGS_LIST = 20
export const MAX_RECORDS_ALLOWED_ON_UPLOAD = 10000
export const BATCH_SIZE_FOR_SONG_UPLOAD = 10000 //100